import React from "react";
import "./PrivacyPolicy.css";
import { Container } from "@mui/material";
const TeamsCondition = () => {
  return (
    <div>
      <Container maxWidth="md" className="privacy">
        <h1 className="pri">Terms And Conditions</h1>
        <h4 className="poi">Terms Of Service Agreement</h4>
        <h6>As on 04-11-2021</h6>
        <p className="para">
          PLEASE READ THIS TERMS OF SERVICE AGREEMENT CAREFULLY. BY USING THIS
          WEBSITE OR ORDERING PRODUCTS FROM THIS WEBSITE YOU AGREE TO BE BOUND
          BY ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT. <br /> <br />This Terms of
          Service Agreement (the "Agreement") governs your use of this website,
          https://www. aganadhigaram.com/ (the "Website"), Agan Adhigaram
          Publishing house® ("Business Name") offer of products for purchase on
          this Website, or your purchase of products available on this Website.
          This Agreement includes, and incorporates by this reference, the
          policies and guidelines referenced below. Agan Adhigaram Publishing
          house® reserves the right to change or revise the terms and conditions
          of this Agreement at any time by posting any changes or a revised
          Agreement on this Website. Agan Adhigaram Publishing house® will alert
          you that changes or revisions have been made by indicating on the top
          of this Agreement the date it was last revised. The changed or revised
          Agreement will be effective immediately after it is posted on this
          Website. Your use of the Website following the posting of any such
          changes or a revised Agreement will constitute your acceptance of any
          such changes or revisions. Agan Adhigaram Publishing house® encourages
          you to review this Agreement whenever you visit the Website to make
          sure that you understand the terms and conditions governing the use of
          the Website. This Agreement does not alter in any way the terms or
          conditions of any other written agreement you may have with Agan
          Adhigaram Publishing house® for other products or services. If you do
          not agree to this Agreement (including any referenced policies or
          guidelines), please immediately terminate your use of the Website. If
          you would like to print this Agreement, please click the print button
          on your browser toolbar.
        </p>
        <h4 className="poi">I. PRODUCTS</h4>
        <p className="para">
          Terms of Offer. This Website offers for sale of certain products (the
          "Products"). By placing an order for Products through this Website,
          you agree to the terms outlined in this Agreement.<br /> <br /> Customer
          Solicitation: Unless you follow one of the below mentioned opt-out
          procedures, of your desire to opt-out from further direct company
          communications and solicitations, you are agreeing to continue to
          receive further emails and call solicitations from Agan Adhigaram
          Publishing house® and it’s designated in house or third-party call
          team(s).<br /> <br /> Opt-Out Procedure: We provide 3 easy ways to opt-out from
          future solicitations. 1. You may use the opt-out link found in any
          email solicitation that you may receive. 2. You may also choose to
          opt-out, via sending your email address to aganadhigaram@gmail.com  <br /> <br />3.
          You may send a written remove request to Agan Adhigaram Publishing
          house®, No 35, Gandhi salai, Chengalpattu- 603002. <br /> <br />Proprietary Rights.
          Agan Adhigaram Publishing house® has proprietary rights and trade
          secrets in the Products. You may not copy, reproduce, resell or
          redistribute any Product manufactured and/or distributed by Agan
          Adhigaram Publishing house®. Agan Adhigaram Publishing house® also has
          rights to all trademarks and trade dress and specific layouts of this
          webpage, including calls to action, text placement, images, and other
          information. Sales Tax. If you purchase any Products, you will be
          responsible for paying any applicable sales tax.
        </p>
        <h4 className="poi">II. WEBSITE</h4>
        <p className="para">
          Content; Intellectual Property; Third-Party Links. In addition to
          making Products available, this Website also offers information and
          marketing materials. This Website also offers information, both
          directly and through indirect links to third-party websites. Agan
          Adhigaram Publishing house® does not always create the information
          offered on this Website; instead, the information is often gathered
          from other sources. To the extent that Agan Adhigaram Publishing
          house® does create the content on this Website, such content is
          protected by intellectual property laws of India, foreign nations, and
          international bodies. Unauthorized use of the material may violate
          copyright, trademark, and/or other laws. You acknowledge that your use
          of the content on this Website is for personal, non-commercial use.
          Any links to third-party websites are provided solely as a convenience
          to you. Agan Adhigaram Publishing house® does not endorse the contents
          on any such third-party websites. Agan Adhigaram Publishing house® is
          not responsible for the content of or any damage that may result from
          your access to or reliance on these third-party websites. If you link
          to third-party websites, you do so at your own risk. <br /> <br />Use of Website;
          Agan Adhigaram Publishing house® is not responsible for any damages
          resulting from the use of this website by anyone. You will not use the
          Website for illegal purposes. You will (1) abide by all applicable
          local, state, national, and international laws and regulations in your
          use of the Website (including laws regarding intellectual property),
          (2) not interfere with or disrupt the use and enjoyment of the Website
          by other users, (3) not resell material on the Website, (4) not
          engage, directly or indirectly, in the transmission of "spam", chain
          letters, junk mail or any other type of unsolicited communication, and
          (5) not defame, harass, abuse, or disrupt other users of the Website<br /> <br /> 
          License.By using this Website, you are granted a limited,
          non-exclusive, non-transferable right to use the content and materials
          on the Website in connection with your normal, non-commercial, use of
          the Website. You may not copy, reproduce, transmit, distribute, or
          create derivative works of such content or information without express
          written authorization from Agan Adhigaram Publishing house® or the
          applicable third party (if third party content is at issue). <br /> <br /> Posting.
          By posting, storing, or transmitting any content on the Website, you
          hereby grant Agan Adhigaram Publishing house® a perpetual, worldwide,
          non-exclusive, royalty-free, assignable, right and license to use,
          copy, display, perform, create derivative works from, distribute, have
          distributed, transmit and assign such content in any form, in all
          media now known or hereinafter created, anywhere in the world. Agan
          Adhigaram Publishing house® does not have the ability to control the
          nature of the user-generated content offered through the Website. You
          are solely responsible for your interactions with other users of the
          Website and any content you post. Agan Adhigaram Publishing house® is
          not liable for any damage or harm resulting from any posts by or
          interactions between users. Agan Adhigaram Publishing house® reserves
          the right but has no obligation, to monitor interactions between and
          among users of the Website and to remove any content Agan Adhigaram
          Publishing house® deems objectionable, in Agan Adhigaram Publishing
          house®’s sole discretion.
        </p>
        <h4 className="poi">III. DISCLAIMER OF WARRANTIES</h4>
        <p className="para">
          YOUR USE OF THIS WEBSITE AND/OR PRODUCTS ARE AT YOUR SOLE RISK. THE
          WEBSITE AND PRODUCTS ARE OFFERED ON AN "AS IS" AND "AS AVAILABLE"
          BASIS. AGAN ADHIGARAM PUBLISHING HOUSE® EXPRESSLY DISCLAIMS ALL
          WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT
          LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE AND NON-INFRINGEMENT WITH RESPECT TO THE PRODUCTS
          OR WEBSITE CONTENT, OR ANY RELIANCE UPON OR USE OF THE WEBSITE CONTENT
          OR PRODUCTS. ("PRODUCTS" INCLUDE TRIAL PRODUCTS.)<br /> <br />  WITHOUT LIMITING THE
          GENERALITY OF THE FOREGOING, AGAN ADHIGARAM PUBLISHING HOUSE® MAKES NO
          WARRANTY: <br /> <br /> THAT THE INFORMATION PROVIDED ON THIS WEBSITE IS ACCURATE,
          RELIABLE, COMPLETE, OR TIMELY.<br /> <br />  THAT THE LINKS TO THIRD-PARTY WEBSITES
          ARE TO INFORMATION THAT IS ACCURATE, RELIABLE, COMPLETE, OR TIMELY.<br /> <br />  NO
          ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM
          THIS WEBSITE WILL CREATE ANY WARRANTY NOT EXPRESSLY STATED HEREIN.<br /> <br />  AS
          TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE PRODUCTS OR
          THAT DEFECTS IN PRODUCTS WILL BE CORRECTED.<br /> <br />  REGARDING ANY PRODUCTS
          PURCHASED OR OBTAINED THROUGH THE WEBSITE.<br /> <br />  SOME JURISDICTIONS DO NOT
          ALLOW THE EXCLUSION OF CERTAIN WARRANTIES, SO SOME OF THE ABOVE
          EXCLUSIONS MAY NOT APPLY TO YOU.
        </p>
        <h4 className="poi">IV. LIMITATION OF LIABILITY</h4>
        <p className="para">
          AGAN ADHIGARAM PUBLISHING HOUSE® ENTIRE LIABILITY, AND YOUR EXCLUSIVE
          REMEDY, IN LAW, IN EQUITY, OR OTHERWISE, WITH RESPECT TO THE WEBSITE
          CONTENT AND PRODUCTS AND/OR FOR ANY BREACH OF THIS AGREEMENT IS SOLELY
          LIMITED TO THE AMOUNT YOU PAID, LESS SHIPPING AND HANDLING, FOR
          PRODUCTS PURCHASED VIA THE WEBSITE. <br /> <br />     AGAN ADHIGARAM PUBLISHING HOUSE®
          WILL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL OR
          CONSEQUENTIAL DAMAGES IN CONNECTION WITH THIS AGREEMENT OR THE
          PRODUCTS IN ANY MANNER, INCLUDING LIABILITIES RESULTING FROM (1) THE
          USE OR THE INABILITY TO USE THE WEBSITE CONTENT OR PRODUCTS; (2) THE
          COST OF PROCURING SUBSTITUTE PRODUCTS OR CONTENT; (3) ANY PRODUCTS
          PURCHASED OR OBTAINED OR TRANSACTIONS ENTERED INTO THROUGH THE
          WEBSITE; OR (4) ANY LOST PROFITS YOU ALLEGE.<br /> <br />  SOME JURISDICTIONS DO NOT
          ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR
          CONSEQUENTIAL DAMAGES SO SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY
          TO YOU.
        </p>
        <h4 className="poi">V. INDEMNIFICATION</h4>
        <p className="para">
          You will release, indemnify, defend and hold harmless Agan Adhigaram
          Publishing house®, and any of its contractors, agents, employees,
          officers, directors, shareholders, affiliates and assigns from all
          liabilities, claims, damages, costs, and expenses, including
          reasonable attorneys' fees and expenses, of third parties relating to
          or arising out of<br /> <br />  (1) this Agreement or the breach of your warranties,
          representations and obligations under this Agreement; <br /> <br /> (2) the Website
          content or your use of the Website content; <br /> <br /> (3) the Products or your
          use of the Products (including Trial Products);<br /> <br />  (4) any intellectual
          property or another proprietary right of any person or entity; <br /> <br /> (5)
          your violation of any provision of this Agreement; or <br /> <br /> (6) any
          information or data you supplied to Agan Adhigaram Publishing house®.<br /> <br /> 
          When Agan Adhigaram Publishing house® is threatened with suit or sued
          by a third party, Agan Adhigaram Publishing house® may seek written
          assurances from you concerning your promise to indemnify Agan
          Adhigaram Publishing house®; your failure to provide such assurances
          may be considered by Agan Adhigaram Publishing house® to be a material
          breach of this Agreement. Agan Adhigaram Publishing house will have
          the right to participate in any defense by you of a third-party claim
          related to your use of any of the Website content or Products, with
          counsel of Agan Adhigaram Publishing house choice at its expense. Agan
          Adhigaram Publishing house® will reasonably cooperate in any defense
          by you of a third-party claim at your request and expense. You will
          have sole responsibility to defend Agan Adhigaram Publishing house®
          against any claim, but you must receive Agan Adhigaram Publishing
          house® prior written consent regarding any related settlement. The
          terms of this provision will survive any termination or cancellation
          of this Agreement or your use of the Website or Products.
        </p>
        <h4 className="poi">VI. PRIVACY</h4>
        <p className="para">
          Agan Adhigaram Publishing house® believes strongly in protecting user
          privacy. Please refer to Agan Adhigaram Publishing house® privacy
          policy, incorporated by reference herein, that is posted on the
          Website.
        </p>
        <h4 className="poi">VII. AGREEMENT TO BE BOUND</h4>
        <p className="para">
          By using this Website or ordering Products, you acknowledge that you
          have read and agree to be bound by this Agreement and all terms and
          conditions on this Website.{" "}
        </p>
        <h4 className="poi">VIII. GENERAL</h4>
        <p className="para">
          Force Majeure. Agan Adhigaram Publishing house® will not be deemed in
          default hereunder or held responsible for any cessation, interruption,
          or delay in the performance of its obligations hereunder due to
          earthquake, flood, fire, storm, natural disaster, the act of God, war,
          terrorism, armed conflict, labor strike, lockout, or boycott.<br /> <br /> 
          Cessation of Operation. Agan Adhigaram Publishing house® may at any
          time, in its sole discretion and without advance notice to you, cease
          operation of the Website and distribution of the Products. Entire
          Agreement. This Agreement comprises the entire agreement between you
          and Agan Adhigaram Publishing house® and supersedes any prior
          agreements about the subject matter contained herein.<br /> <br />   Effect of
          Waiver. The failure of Agan Adhigaram Publishing house® to exercise or
          enforce any right or provision of this Agreement will not constitute a
          waiver of such right or provision. If any provision of this Agreement
          is found by a court of competent jurisdiction to be invalid, the
          parties nevertheless agree that the court should endeavor to give
          effect to the parties' intentions as reflected in the provision, and
          the other provisions of this Agreement remain in full force and
          effect. <br /> <br /> Governing Law; Chengalpattu. This Website originates from
          Chengalpattu, Tamilnadu. This Agreement will be governed by the laws
          of the State of Tamilnadu without regard to its conflict of law
          principles to the contrary. Neither you nor Agan Adhigaram Publishing
          house® will commence or prosecute any suit, proceeding, or claim to
          enforce the provisions of this Agreement, to recover damages for
          breach of or default of this Agreement, or otherwise arising under or
          because of this Agreement, other than in courts located in the State
          of Tamilnadu By using this Website or ordering Products, you consent
          to the jurisdiction and venue of such courts in connection with any
          action, suit, proceeding or claim to arise under or because of this
          Agreement. You hereby waive any right to trial by jury arising out of
          this Agreement and any related documents.<br /> <br />    Statute of Limitation. You
          agree that regardless of any statute or law to the contrary, any claim
          or cause of action arising out of or related to use of the Website or
          Products or this Agreement must be filed within one (1) year after
          such claim or cause of action arose or be forever barred. <br /> <br /> Waiver of
          Class Action Rights. BY ENTERING INTO THIS AGREEMENT, YOU HEREBY
          IRREVOCABLY WAIVE ANY RIGHT YOU MAY HAVE TO JOIN CLAIMS WITH THOSE OF
          OTHER IN THE FORM OF A CLASS ACTION OR SIMILAR PROCEDURAL DEVICE. ANY
          CLAIMS ARISING OUT OF, RELATING TO, OR CONNECTION WITH THIS AGREEMENT
          MUST BE ASSERTED INDIVIDUALLY. <br /> <br /> Termination. Agan Adhigaram Publishing
          house® reserves the right to terminate your access to the Website if
          it reasonably believes, in its sole discretion, that you have breached
          any of the terms and conditions of this Agreement. Following
          termination, you will not be permitted to use the Website and Agan
          Adhigaram Publishing house® may, in its sole discretion and without
          advance notice to you, cancel any outstanding orders for Products. If
          your access to the Website is terminated, Agan Adhigaram Publishing
          house® reserves the right to exercise whatever means it deems
          necessary to prevent unauthorized access to the Website. This
          Agreement will survive indefinitely unless and until Agan Adhigaram
          Publishing house® chooses, in its sole discretion and without advance
          to you, to terminate it.<br /> <br />  Domestic Use. Agan Adhigaram Publishing
          house® makes no representation that the Website or Products are
          appropriate or available for use in locations outside India. Users who
          access the Website from outside India do so at their own risk and
          initiative and must bear all responsibility for compliance with any
          applicable local laws. <br /> <br /> Assignment. You may not assign your rights and
          obligations under this Agreement to anyone. Agan Adhigaram Publishing
          house® may assign its rights and obligations under this Agreement in
          its sole discretion and without advance notice to you.<br /> <br />  BY USING THIS
          WEBSITE OR ORDERING PRODUCTS FROM THIS WEBSITE YOU AGREE TO BE BOUND
          BY ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT.
        </p>
      </Container>
    </div>
  );
};

export default TeamsCondition;
